import { red } from '@mui/material/colors';
import { components } from './components';

const themeOptions = {
  typography: {
    fontSize: 14,
    body1: {
      fontSize: '14px'
    }
  },

  shape: {
    borderRadius: 0
  },

  status: {
    danger: red[500]
  },
  components: {
    ...components
  }
};

export default themeOptions;
